/* Redirect cart page to homepage and open the mini cart */

if (window.location.hash == "#cart") {
  document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
    bubbles: true,
    detail: {
      openMiniCart: window.themeVariables.settings.cartType === "drawer"
    }
  }));
}

/* ________ CHANGE SELECTED VARIANT ON CLICK ________ */
let options = document.querySelectorAll('.product-item__option:not(.out-of-stock)');
options.forEach(option => {
  option.addEventListener('click', function () {
    let currentQuickAdd = option.closest('.product-item__quick-add');
    let inputWithVariantId = currentQuickAdd.querySelector('input[name="id"]');
    let selectedOption = currentQuickAdd.querySelector('.product-item__option.is-selected');
    selectedOption.classList.remove('is-selected');
    option.classList.add('is-selected');

    // Get the variant id of the selected option
    let variantId = option.getAttribute('data-variant-id');

    // Put the variant id into the input field
    inputWithVariantId.setAttribute('value', variantId);
  });
});

/* ________________ QUICK ADD ________________ */

let items = document.querySelectorAll('.product-item ');
items.forEach(item => {
  item.addEventListener('mouseenter', function () {
    // Calculate if it needs to display the show more button
    displayShowMoreButton(item);
  });
  item.addEventListener('mouseleave', function () {
    let lessButton = item.querySelector('.product-item__less-icon');
    let plusButton = item.querySelector('.product-item__plus-icon');

    // Hide less button after the close animation
    setTimeout(function () {
      lessButton.classList.add('hide');
      plusButton.classList.remove('hide');
    }, 200);
  });
});

/* FUNCTIONS */

function displayShowMoreButton(item) {
  // Get the elements heights
  let optionHeight = item.querySelector('.product-item__option').offsetHeight;
  let optionContainer = item.querySelector('.product-item__sizes-container');
  let optionContainerHeight = optionContainer.offsetHeight;

  // Get the show more buttons
  let showMoreButton = item.querySelector('.product-item__show-more');
  let plusButton = item.querySelector('.product-item__plus-icon');
  let lessButton = item.querySelector('.product-item__less-icon');

  // If the option container is bigger than the option height :
  // Display the show more button and set a new height to the options container
  if (optionContainerHeight > optionHeight) {
    showMoreButton.classList.remove('hide');
    optionContainer.style.height = optionHeight + 'px';
    openOptionsDropdown(optionContainer, optionContainerHeight, plusButton, lessButton);
    closeOptionsDropdown(optionContainer, optionHeight, plusButton, lessButton);
  }
}
function openOptionsDropdown(container, containerHeight, plusButton, lessButton) {
  // Open the dropdown and hide plus button
  plusButton.addEventListener('click', () => {
    container.style.height = containerHeight + 'px';
    plusButton.classList.add('hide');
    lessButton.classList.remove('hide');
  });
}
function closeOptionsDropdown(container, optionHeight, plusButton, lessButton) {
  // Close dropdown and hide less button
  lessButton.addEventListener('click', () => {
    container.style.height = optionHeight + 'px';
    plusButton.classList.remove('hide');
    lessButton.classList.add('hide');
  });
}